import React, {useContext, useMemo, useState } from "react";
import Toptab from "../../../component/TopTab/TopTab";
import Procurement from "./procurement";
import Sales from "./Sales";
import Manufacturing from "./Munufecturing";
import BuildingPacking from "./BuildingPacking";
import Inventory from "./Inventory";
import Masters from "./Msater";
import { AppContext } from "../../../context/AppContext";

const tabs = [

    { id: "Procurement", label: "procurement", content: <Procurement />, permissionKey: "View Procurement" },
    { id: "Sales", label: "Sales", content: <Sales />, permissionKey:"View Sales" },
    { id: "Manufacturing", label: "Manufacturing", content: <Manufacturing />, permissionKey:"View Manufacturing"  },
    { id: "BuildingPacking", label: "Building & Packing", content: <BuildingPacking />, permissionKey:"View Building & Packing"  },
    { id: "Inventory", label: "Inventory", content: <Inventory />, permissionKey:"View Inventory"  },
    { id: "Masters", label: "Masters", content: <Masters />, permissionKey:"View Masters"  },
];

const ErpManagement = () => {
   

    const { permissions } = useContext(AppContext);

    // 1. Pehle filter karein (Initialization order fix)
    const filteredTabs = useMemo(() => {
        return tabs.filter(tab => permissions && permissions[tab.permissionKey]);
    }, [permissions]);

    // 2. Phir state define karein
    const [activeTab, setActiveTab] = useState(
        filteredTabs.length > 0 ? filteredTabs[0].id : ""
    );

    return (
        <div className="d-flex flex-column " style={{ overflow: "auto" }}>
            {/* Breadcrumb with activeTab passed as a prop */}
            {/* <Breadcrumps activeTab={activeTab} /> */}

            {/* Toptab with activeTab and setActiveTab passed as props */}

           {filteredTabs.length > 0 ? (
                <Toptab 
                    activeTab={activeTab} 
                    setActiveTab={setActiveTab}
                    tabs={filteredTabs} 
                />
            ) : (
                <div className="p-4 text-center">
                    <h6>You don't have permission to view any modules.</h6>
                </div>
            )}

            {/* Content */}
            {/* <div className="container mt-4"></div> */}
        </div>
    );
};

export default ErpManagement;
